import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import { notForPreview } from 'widget/utils/not-for-preview';

import { openFullScreenOverlay, openFullScreenSubscribeOverlay } from 'shared/utils/open-overlay';
import paymentsHelper from 'widget/utils/payments';

import {
  getSiteUrl,
  getInstance,
} from 'shared/selectors/app-settings';


@connect(store => ({
  siteUrl: getSiteUrl(store),
  instance: getInstance(store),
}))
export default class ChannelActionCallbacks extends React.Component {

  static propTypes = {
    children: React.PropTypes.element.isRequired,
    channelId: React.PropTypes.string,
    siteUrl: React.PropTypes.string,
    instance: React.PropTypes.string,
  };

  @autobind
  @notForPreview
  showChannelInfoAtOverlay() {
    openFullScreenOverlay(`#/channel/${this.props.channelId}/info`);
  }

  @autobind
  @notForPreview
  showChannelSubscriptionInfoAtOverlay() {
    openFullScreenSubscribeOverlay(this.props.channelId);
  }

  @autobind
  @notForPreview
  cancelChannelSubscription() {
    const { siteUrl, instance, channelId } = this.props;
    paymentsHelper.cancelSubscription(channelId, siteUrl, instance);
  }

  render() {
    return React.cloneElement(this.props.children, {
      onInfoRequest: this.showChannelInfoAtOverlay,
      onSubscriptionRequest: this.showChannelSubscriptionInfoAtOverlay,
      onSubscriptionCancelRequest: this.cancelChannelSubscription,
    });
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/actions/channel-action-callbacks.js